export class SelectWaybill {
    id: String;
    value:String;
  }
  